import { Location } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Service } from "../../../models/service";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";
import { BaseError } from "../base-error";

@Component({
  selector: "app-service-dashboard",
  templateUrl: "./service-dashboard.component.html",
  providers: [ServiceControllerService, ToastrService],
})
export class ServiceDashboardComponent extends BaseError implements OnInit {

  @Input() public showPublish = true;
  @Output() public serviceUpdated = new EventEmitter();
  public serviceId: string;
  public service: Service = new Service();
  public services: any[];

  constructor(private serviceControllerService: ServiceControllerService,
              private route: ActivatedRoute, private router: Router, location: Location,
              public toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
      if (this.serviceId !== null) {
        this.loadService();
      } else {
        this.service = new Service();
      }
    });
  }

  public loadService() {
    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => {
        this.service = data;
      },
    );
  }

}
